
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { apiSlice } from '../apiSlice';

export const selectDynamicFormListRaw = (state: RootState) => apiSlice.endpoints.getDynamicFormList.select()(state);

export const selectDynamicFormListLoaded = createSelector(
  [selectDynamicFormListRaw],
  (slice) => slice.status === 'fulfilled'
);

export const selectDynamicFormListLoading = createSelector(
  [selectDynamicFormListRaw],
  (slice) =>  slice.isLoading
);

export const selectDynamicFormList = createSelector(
  [selectDynamicFormListRaw],
  ({ data }) =>  data
);

export const selectDynamicFormListStatus = createSelector(
  [selectDynamicFormListRaw],
  (slice) =>  slice.status
);
